const initialState = {
  userToken: "",
  userType: "",
  userData: {}
};

export default function authReducer(state = initialState, action) {
  switch (action.type) {
    case "SET_USER_TOKEN":
      return {
        ...state,
        userToken: action.userToken,
      };
    case "SET_USER_TYPE":
      return {
        ...state,
        userType: action.userType,
      };
    case "SET_USER_DATA":
      return {
        ...state,
        userData: action.userData,
      };
    case "LOGOUT":
      return {
        userToken: "",
        userType: "",
      };
    default:
      return state;
  }
}
